import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {SharedModule} from '../../shared/shared.module';
import {OwlModule} from 'angular-owl-carousel';
import {ContactPageComponent} from './contact.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        ContactPageComponent
    ],

    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        SharedModule,
        OwlModule,
        LazyLoadImageModule,
        GoogleMapsModule,
        ReactiveFormsModule
    ]
})

export class ContactModule {
}
